// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button.icon-rename[data-v-1255f89b]{background-color:transparent;border:none;opacity:0.3}.button.icon-rename[data-v-1255f89b]:hover,.button.icon-rename[data-v-1255f89b]:focus{opacity:1}\n", ""]);
// Exports
module.exports = exports;
